export const CPA_SESSION_STORAGE_KEY = 'cpa_session_id';
export const CPA_SESSION_UPDATED_AT_KEY = 'cpa_session_updated_at';
export const CPA_SESSION_MAX_AGE_MS = 60 * 60 * 1000; // 1 hour

export const ORG_TYPE_OPTIONS = [
    { value: 'ed_tech', label: 'Ed-Tech / Program Provider' },
    { value: 'international_school', label: 'International School' },
    { value: 'network_of_schools', label: 'Network of Schools' },
    { value: 'training_partner', label: 'Training Partner' },
    { value: 'government_ministry', label: 'Government / Ministry' },
    { value: 'ngo', label: 'NGO' },
    { value: 'other', label: 'Other' },
];

export const GOAL_OPTIONS = [
    { value: 'sell_deliver_assessments', label: 'Sell and deliver assessments to my network' },
    { value: 'assess_own_company', label: 'Assess my own company' },
    { value: 'build_ai_digital_literacy', label: 'Build AI-digital literacy programs' },
    { value: 'build_ecosystem', label: 'Build an ecosystem' },
    { value: 'align_global_standards', label: 'Get my program aligned to the global standards' },
    { value: 'prove_impact', label: "Prove my program's impact for funding or board approval" },
    { value: 'build_framework', label: 'Build a Framework' },
    { value: 'other', label: 'Other' },
];

export const COUNT_BAND_OPTIONS = [
    { value: '', label: 'Select…' },
    { value: 'under_100', label: 'Under 100' },
    { value: '100_500', label: '100 – 500' },
    { value: '500_1000', label: '500 – 1,000' },
    { value: '1000_5000', label: '1,000 – 5,000' },
    { value: '5000_10000', label: '5,000 – 10,000' },
    { value: '10000_plus', label: '10,000+' },
];

export const ROLLOUT_OPTIONS = [
    { value: '', label: 'Select…' },
    { value: 'immediate', label: 'Immediately' },
    { value: '1_3_months', label: '1 – 3 months' },
    { value: '3_6_months', label: '3 – 6 months' },
    { value: '6_12_months', label: '6 – 12 months' },
    { value: '12_plus_months', label: '12+ months' },
];

export const PACKAGE_INFO = {
    P0: {
        id: 'P0',
        title: 'CPC Index Partner & Reseller Package',
        subtitle: 'A ready-to-deliver child online-safety assessment product — no R&D and no framework to build yourself.',
        description: 'Resell and run standardized Child Protection in Cyberspace (CPC) Index assessments across schools, districts, and whole nations. The CPC Index is your credibility advantage — an internationally benchmarked framework that ministries and school boards already trust.',
        features: ['All 7 standardized COS packs (SP-01–07)', 'Per-respondent learner scorecards', 'Partner / network / national dashboards', 'Every result rolls up to the CPC Index'],
        // P0-specific UI fields
        accentColor: '#0B447C',
        cardBgColor: '#EEF3FF',
        tags: ['Partner & reseller tier', 'PRO account'],
        highlights: [
            { icon: '▲', title: 'Go live in days',           desc: 'Launch a standards-aligned offering fast.' },
            { icon: '★', title: 'Built-in differentiation',  desc: "A global index competitors can't match." },
            { icon: '◆', title: 'National-scale impact',     desc: 'Show nations their true CPC levels.' },
        ],
        rightHeading: 'What every package includes',
        infoItems: [
            { title: 'PRO partner dashboard',         detail: 'One control center for analytics, deployment tracking, and CPC benchmarking across your whole portfolio of schools and regions.' },
            { title: 'Full assessment library',       detail: 'Standardized assessments for students, parents, teachers, school leaders, companies, and government stakeholders.' },
            { title: 'Real-time dashboards per client', detail: 'Each school or organization you onboard gets its own live dashboard, generated for you automatically.' },
            { title: 'Individual learner scorecards', detail: 'Every learner gets a clear personal scorecard, making progress and impact easy to see and report on.' },
            { title: 'Scales from pilots to nations', detail: 'One infrastructure that supports 5,000 to 1M+ learners, so you can grow from a single district to a national rollout.' },
            { title: 'Regional & global benchmarking', detail: 'Compare any school, region, or nation against national and international standards through the CPC Index.' },
        ],
        highlightBox: {
            title: 'Help nations see where they stand',
            desc: "Aggregate results give governments a clear, benchmarked picture of children's online safety — pinpointing CPC strengths and gaps to guide policy and protection priorities.",
        },
        ctaButtons: [
            { label: 'About the CPC Index Initiative' },
            { label: 'View Japan Ed-Tech Reseller Case Study' },
        ],
        tabs: [
            { id: 'package',    label: 'Package Info' },
            { id: 'assessment', label: 'Preview Assessment' },
            { id: 'dashboard',  label: 'Preview PRO Dashboard' },
        ],
    },
    P1: {
        id: 'P1',
        title: 'AI-Digital Literacy Learning Tracker',
        subtitle: 'Measure where learners stand, upskill them, and prove the improvement.',
        description: 'For corporates, international schools, NGOs and education companies that want to do more than assess — build the programs that close the gaps and track real capability growth over time.',
        features: ['Unlimited custom assessments (AssessCreator)', 'LearnCreator program builder', 'Embedded pre & post assessment', 'Tiered learner licenses'],
        // P1-specific UI fields
        accentColor: '#15704F',
        cardBgColor: '#E4F3EC',
        tags: ['Measure & learn tier', 'Solution package'],
        cardCta: { label: 'Try Learning Creator' },
        highlights: [
            { icon: '▲', title: 'Measure, then improve',  desc: 'Baseline, upskill, and re-measure in one loop.' },
            { icon: '◆', title: 'Build your own programs', desc: 'Custom learning, not off-the-shelf content.' },
            { icon: '⬡', title: 'Proof of improvement',   desc: 'Before-and-after data leaders can trust.' },
        ],
        rightHeading: 'What this package includes',
        infoItems: [
            { title: 'Custom Assessment Builder',      detail: 'Create unlimited assessments tailored to your learners, roles or competencies.' },
            { title: 'Baseline assessment licenses',   detail: 'Licensed by tier — from under 1,000 to 10,000+ learners assessed.' },
            { title: 'LearnCreator program builder',   detail: 'Build full multi-session programs with AI-generated, framework-aligned content.' },
            { title: 'Embedded pre & post assessment', detail: 'Every program measures the improvement it creates, automatically.' },
            { title: '3-layer analytics dashboard',    detail: 'See results by learner, group and organisation in real time.' },
            { title: 'Style & branding controls',      detail: 'Adapt look, tone and language to your organisation and audience.' },
        ],
        highlightBox: {
            title: 'From a number to a trajectory',
            desc: "Don't just learn where learners stand today — show measurable capability growth over time, with assessment and learning working as one connected system.",
        },
        ctaButtons: [
            { label: 'View LEGO Case Study' },
        ],
    },
    P2: {
        id: 'P2',
        title: 'AI-Digital Literacy Impact Validation',
        subtitle: 'Validate your programs, certify their quality, and stand out in the market.',
        description: 'For NGOs, education companies and EdTech platforms that already have content — and now need independent credibility, impact evidence and a quality mark buyers recognise.',
        features: ['Alignment scoring engine (DQ Stars)', '1–5 star rating & certification mark', 'Board-grade impact reporting', 'Marketplace listing & co-branding'],
        // P2-specific UI fields
        accentColor: '#5A3FA0',
        cardBgColor: '#EDE8F8',
        tags: ['Validate & certify tier', 'Solution package'],
        cardCta: { label: 'View Sample Ratings Report' },
        highlights: [
            { icon: '★', title: 'Independent validation',  desc: 'Your programs, checked against the standard.' },
            { icon: '◆', title: 'Certified quality mark',  desc: 'A DQ Stars badge buyers already trust.' },
            { icon: '▲', title: 'Market differentiation',  desc: 'Proven impact sets you apart from rivals.' },
        ],
        rightHeading: 'What this package includes',
        infoItems: [
            { title: 'Alignment scoring engine',          detail: 'Score how well your programs align to recognised competencies and standards.' },
            { title: 'Expert feedback sessions',          detail: 'Structured review from DQ specialists to strengthen your content.' },
            { title: 'DQ Stars Rating & mark',            detail: 'Earn a 1–5 star quality rating and the certification mark to display it.' },
            { title: 'Annual reassessment cycle',         detail: 'Keep your validation current as your programs evolve year on year.' },
            { title: 'Board-grade impact reporting',      detail: 'A published impact report built for executives and funders.' },
            { title: 'Marketplace listing & co-branding', detail: 'List your validated program alongside the DQ brand for added reach.' },
        ],
        highlightBox: {
            title: 'Turn quality into a credential',
            desc: "Buyers and ministries shortlist what they can trust. Validation makes your impact visible, independent and provable — the credibility layer your content was missing.",
        },
        ctaButtons: [
            { label: 'TechnoKids Case Study' },
        ],
    },
    P3: {
        id: 'P3',
        title: 'AI-Digital Literacy System',
        subtitle: 'Define a national framework, certify the ecosystem, and govern it at scale.',
        description: 'For governments, ministries, national agencies and large enterprises building AI-digital literacy as full national infrastructure — framework, assessment, learning, certification and registry.',
        features: ['Full AssessCreator + LearnCreator suites', 'Full FrameworkCreator + DQ Stars certification', 'Full DQ Index Connect benchmarking', 'National & regional partner dashboards'],
        // P3-specific UI fields
        accentColor: '#0C5E66',
        cardBgColor: '#E0F0F1',
        tags: ['Flagship tier', 'National system'],
        cardCta: { label: 'View Sample National Dashboard' },
        highlights: [
            { icon: '⬡', title: 'A national framework',      desc: 'Your own standard, built and operationalised.' },
            { icon: '◆', title: 'Govern the whole ecosystem', desc: 'Certify programs, teachers and providers.' },
            { icon: '▲', title: 'Benchmarked at scale',       desc: 'Country and sector data against the world.' },
        ],
        rightHeading: 'What this package includes',
        infoItems: [
            { title: 'Full national framework system',    detail: 'Build and operationalise a complete country-grade competency framework.' },
            { title: 'National-scale assessment',         detail: 'Build custom assessments aligned with your framework and connected with a global databank.' },
            { title: 'National learning program suite',   detail: 'LearnCreator at scale — programs for 100,000+ learners, fully localized.' },
            { title: 'DQ Stars at national scale',        detail: 'Rate and certify 100+ programs across your national ecosystem.' },
            { title: 'Teacher certification & registry',  detail: 'Certify national teacher cohorts and run a quality-controlled program registry.' },
            { title: 'National & partner dashboards',     detail: 'One national dashboard plus regional and partner dashboards, plus CPC Index.' },
        ],
        highlightBox: {
            title: 'The infrastructure a nation governs from',
            desc: 'Not a product, but a system — framework, measurement, learning and certification, connected and benchmarked, so policy and funding are guided by real national evidence.',
        },
        ctaButtons: [
            { label: 'GB Case Study' },
        ],
    },
    P4: {
        id: 'P4',
        title: 'Framework Creator',
        subtitle: 'Design your AI-digital literacy framework, aligned to global standards.',
        description: 'For corporates, early-stage LMS platforms and governments in exploration — the fast, low-risk first step into the PbDQ ecosystem, with a clear upgrade path to a full national system.',
        features: ['Guided 5-step Framework Builder', 'Framework documentation (PDF / JSON / CSV)', 'Auto-map to IEEE 3527.1 / UNESCO / OECD', 'Clear upgrade path to P3'],
        // P4-specific UI fields
        accentColor: '#b06f1c',
        cardBgColor: '#FBEFDA',
        tags: ['Entry tier', 'Gateway product'],
        cardCta: { label: 'View Sample Framework' },
        highlights: [
            { icon: '▲', title: 'A fast first step',         desc: 'Define your framework in 1–2 months.' },
            { icon: '◆', title: 'Global-standard aligned',   desc: 'Built on the PbDQ methodology from day one.' },
            { icon: '●', title: 'A clear upgrade path',      desc: 'Grows into the full P3 national system.' },
        ],
        rightHeading: 'What this package includes',
        infoItems: [
            { title: 'Framework Builder (v0)',        detail: 'Define one complete AI-digital literacy framework for your organisation.' },
            { title: 'Guided 5-step methodology',     detail: 'Questionnaire, analysis, draft, focus group and finalise — fully guided.' },
            { title: 'Framework documentation',       detail: 'Delivered as a polished PDF plus JSON / CSV export for reuse.' },
            { title: 'Mapping Engine (add-on)',        detail: 'Auto-map your framework to IEEE 3527.1, UNESCO and OECD standards.' },
            { title: 'Standards-alignment proof',     detail: 'Visible evidence that your framework meets recognised global benchmarks.' },
            { title: 'Upgrade path',                  detail: 'A clear contract path to operationalise your framework as a national system.' },
        ],
        highlightBox: {
            title: 'The gateway into the DQ ecosystem',
            desc: 'Start small, prove the strategy, and move fast. Most Framework License clients go on to operationalise their framework with the full national system within 12–18 months.',
        },
        ctaButtons: [
            { label: 'NUS Case Study' },
            { label: 'UAE MOE Case Study' },
        ],
    },
};

export const PANEL_TABS = [
    { id: 'package', label: 'Package Info' },
    { id: 'assessment', label: 'Preview Assessment with Learner Scorecard' },
    { id: 'dashboard', label: 'Preview Dashboard' },
];
